(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["formulaire-personnalise"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const forms = document.querySelectorAll('.formulaire-personnalise__form');
    const isDebugMode = new URLSearchParams(window.location.search).get('fp_debug') === '1';

    forms.forEach((form) => {
      const errorBox = form.querySelector('[data-fp-client-error]');
      const errorText = form.querySelector('[data-fp-client-error-text]');
      const debugPanel = form.querySelector('[data-fp-debug-panel]');
      const debugOutput = form.querySelector('[data-fp-debug-output]');
      const debugCopy = form.querySelector('[data-fp-debug-copy]');
      const summaryMessage = form.querySelector('[data-fp-summary-message]');
      const summarySubject = form.querySelector('[data-fp-summary-subject]');
      const groups = Array.from(form.querySelectorAll('[data-fp-required-checkbox-group]'));
      const summaryFields = Array.from(form.querySelectorAll('[data-fp-summary-field]'));

      const showError = (message) => {
        if (!errorBox) {
          return;
        }

        if (errorText) {
          errorText.textContent = message || errorBox.dataset.defaultMessage || '';
        }

        errorBox.hidden = false;
        errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        errorBox.focus({ preventScroll: true });
      };

      const hideError = () => {
        if (errorBox) {
          errorBox.hidden = true;
        }
      };

      const validateGroups = () => {
        let invalidGroup = null;

        groups.forEach((group) => {
          const inputs = Array.from(group.querySelectorAll('input[type="checkbox"]'));
          const firstInput = inputs[0];

          if (!firstInput) {
            return;
          }

          const hasCheckedInput = inputs.some((input) => input.checked);
          const message = group.dataset.errorMessage || errorBox?.dataset.checkboxMessage || '';
          firstInput.setCustomValidity(hasCheckedInput ? '' : message);

          if (!hasCheckedInput && !invalidGroup) {
            invalidGroup = group;
          }
        });

        return invalidGroup;
      };

      const getErrorMessage = (invalidGroup) => {
        if (invalidGroup) {
          return invalidGroup.dataset.errorMessage || errorBox?.dataset.checkboxMessage || '';
        }

        return errorBox?.dataset.defaultMessage || '';
      };

      const getFieldLabel = (field) => {
        const id = field.getAttribute('id');
        const escapedId = id && window.CSS && CSS.escape ? CSS.escape(id) : id;
        const label = escapedId ? form.querySelector(`label[for="${escapedId}"]`) : null;
        const legend = field.closest('fieldset')?.querySelector('legend');

        return field.dataset.fpSummaryLabel || label?.textContent.trim() || legend?.textContent.trim() || field.getAttribute('name') || field.type || 'Champ sans nom';
      };

      const getFieldValue = (field) => {
        if (field.tagName.toLowerCase() === 'select') {
          return field.options[field.selectedIndex]?.textContent.trim() || field.value;
        }

        return field.value;
      };

      const collectSummaryEntries = () => {
        const grouped = new Map();

        summaryFields.forEach((field) => {
          if (field.type === 'radio' && !field.checked) {
            return;
          }

          if (field.type === 'checkbox' && !field.checked) {
            return;
          }

          const label = getFieldLabel(field);
          const value = getFieldValue(field);

          if (!label || value === '') {
            return;
          }

          if (!grouped.has(label)) {
            grouped.set(label, []);
          }

          grouped.get(label).push(value);
        });

        return Array.from(grouped.entries()).map(([label, values]) => ({
          label,
          value: values.join(', '),
        }));
      };

      const updateSummaryMessage = () => {
        if (!summaryMessage) {
          return;
        }

        const lines = [];
        const subject = summarySubject?.value.trim();

        if (subject) {
          lines.push('Objet: ' + subject, '');
        }

        collectSummaryEntries().forEach((entry) => {
          lines.push(entry.label + ': ' + entry.value);
        });

        summaryMessage.value = lines.join('\n');
      };

      const disableInternalNamedFields = () => {
        summaryFields.forEach((field) => {
          const name = field.getAttribute('name') || '';

          if (name && !name.startsWith('contact[')) {
            field.disabled = true;
          }
        });
      };

      const buildDebugSnapshot = () => {
        updateSummaryMessage();

        const formData = new FormData(form);
        const entries = [];
        const invalidFields = Array.from(form.querySelectorAll(':invalid')).map((field) => ({
          label: getFieldLabel(field),
          name: field.getAttribute('name') || '',
          type: field.getAttribute('type') || field.tagName.toLowerCase(),
          value: field.type === 'password' ? '[hidden]' : field.value,
          validationMessage: field.validationMessage,
        }));

        formData.forEach((value, name) => {
          entries.push({
            name,
            value: String(value),
          });
        });

        return {
          debugActive: isDebugMode,
          currentUrl: window.location.href,
          formAction: form.getAttribute('action') || '',
          formMethod: form.getAttribute('method') || '',
          formId: form.getAttribute('id') || '',
          valid: invalidFields.length === 0,
          invalidFields,
          visibleFields: collectSummaryEntries(),
          payload: entries,
          payloadCount: entries.length,
          capturedAt: new Date().toISOString(),
        };
      };

      const saveDebugSnapshot = (snapshot) => {
        try {
          window.sessionStorage.setItem('formulairePersonnaliseLastDebug', JSON.stringify(snapshot));
        } catch (error) {
          return;
        }
      };

      const renderDebugSnapshot = (snapshot) => {
        if (!debugOutput) {
          return;
        }

        debugOutput.textContent = JSON.stringify(snapshot, null, 2);
      };

      validateGroups();

      if (isDebugMode && debugPanel) {
        debugPanel.hidden = false;
        renderDebugSnapshot(buildDebugSnapshot());
      }

      if (debugCopy && debugOutput) {
        debugCopy.addEventListener('click', () => {
          if (!navigator.clipboard) {
            return;
          }

          navigator.clipboard.writeText(debugOutput.textContent || '').then(() => {
            const originalText = debugCopy.textContent;
            debugCopy.textContent = 'Debug copie';

            window.setTimeout(() => {
              debugCopy.textContent = originalText;
            }, 1600);
          });
        });
      }

      groups.forEach((group) => {
        const inputs = Array.from(group.querySelectorAll('input[type="checkbox"]'));

        inputs.forEach((input) => {
          input.addEventListener('change', () => {
            validateGroups();

            if (!form.querySelector(':invalid')) {
              hideError();
            }
          });
        });
      });

      form.addEventListener(
        'invalid',
        (event) => {
          const invalidGroup = event.target.closest('[data-fp-required-checkbox-group]');
          validateGroups();
          showError(getErrorMessage(invalidGroup));

          if (isDebugMode) {
            updateSummaryMessage();
            const snapshot = buildDebugSnapshot();
            saveDebugSnapshot(snapshot);
            renderDebugSnapshot(snapshot);
          }
        },
        true
      );

      form.addEventListener('submit', (event) => {
        const invalidGroup = validateGroups();
        updateSummaryMessage();
        const snapshot = buildDebugSnapshot();

        saveDebugSnapshot(snapshot);

        if (isDebugMode) {
          event.preventDefault();
          renderDebugSnapshot(snapshot);

          if (!form.checkValidity()) {
            showError(getErrorMessage(invalidGroup));

            const invalidField = form.querySelector(':invalid');

            if (invalidField) {
              invalidField.focus({ preventScroll: true });
              invalidField.reportValidity();
            }
          } else {
            hideError();
            debugPanel?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }

          return;
        }

        if (!form.checkValidity()) {
          event.preventDefault();
          showError(getErrorMessage(invalidGroup));

          const invalidField = form.querySelector(':invalid');

          if (invalidField) {
            invalidField.focus({ preventScroll: true });
            invalidField.reportValidity();
          }

          return;
        }

        hideError();
        disableInternalNamedFields();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formulaire"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const groups = document.querySelectorAll('[data-required-checkbox-group]');

    groups.forEach((group) => {
      const inputs = Array.from(group.querySelectorAll('input[type="checkbox"]'));
      const firstInput = inputs[0];

      if (!firstInput) {
        return;
      }

      const validateGroup = () => {
        const hasCheckedInput = inputs.some((input) => input.checked);
        firstInput.setCustomValidity(hasCheckedInput ? '' : group.dataset.errorMessage || '');
      };

      validateGroup();
      inputs.forEach((input) => input.addEventListener('change', validateGroup));
      group.closest('form')?.addEventListener('submit', validateGroup);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
